import React from "react";
import { Link } from "react-router-dom";

import Card from "../../shared/components/UIElements/Card";

const ActionIndicator = ({ action }) => {
  const actionMap = {
    1: { text: "Buy", color: "green" },
    0: { text: "Hold", color: "gray" },
    "-1": { text: "Sell", color: "red" },
  };

  const { text, color } = actionMap[action] || {
    text: "Unknown",
    color: "black",
  };

  return <span style={{ color, fontWeight: "bold" }}>{text}</span>;
};

const TradeItem = (props) => {

  const {
    TRADE_NUMBER,
    DATE_BUY,
    PRICE_BUY,
    PRICE_AVG,
    REBUY_COUNTER,
    DATE_SELL,
    PRICE_SELL,
    HOLD_DUR,
    PRICE_MAX,
    PRICE_MIN,
    MDD,
    PNL,
    onTradeClick, // Accept onTradeClick prop
    isSelected
  } = props;

  // Reconstruct the trade object
  const trade = {
    TRADE_NUMBER,
    DATE_BUY,
    PRICE_BUY,
    PRICE_AVG,
    REBUY_COUNTER,
    DATE_SELL,
    PRICE_SELL,
    HOLD_DUR,
    PRICE_MAX,
    PRICE_MIN,
    MDD,
    PNL,
  };

  const cardStyle = {
    backgroundColor:
    trade.DATE_SELL === null
      ? "rgba(234, 234, 234, 0.5)"
      : parseFloat(props.PNL) > 0
      ? "rgba(0, 255, 0, 0.5)"
      : "rgba(255, 0, 0, 0.5)",
    borderWidth: "4px",
    borderStyle: "solid",
    borderColor: isSelected ? "blue" : trade.DATE_SELL === null ? "black" : "transparent",
    borderRadius: "4px", // Optional: to make the border corners rounded
    cursor: "pointer", // Indicate that the item is clickable
  };

  return (
      <Card className="instrument-item" style={cardStyle}>
        <table className="trade-table" onClick={() => onTradeClick(trade)}>
          <tbody>
            <tr>
              {/* <td><ActionIndicator action={props.action} /></td> */}
              <td>{trade.TRADE_NUMBER}</td>
              <td>{trade.DATE_BUY}</td>
              <td>{trade.PRICE_BUY}</td>
              <td>{trade.PRICE_AVG ?? trade.PRICE_BUY}</td>
              <td>{trade.REBUY_COUNTER ?? 0}</td>
              <td>{trade.DATE_SELL}</td>
              <td>{trade.PRICE_SELL}</td>
              <td>{trade.HOLD_DUR}</td>
              <td>{trade.PRICE_MAX}</td>
              <td>{trade.PRICE_MIN}</td>
              <td>{trade.MDD}</td>
              <td>{trade.PNL}</td>
            </tr>
          </tbody>
        </table>
      </Card>
  );
};

export default TradeItem;
